"use client";

import React, { createContext, useContext } from "react";
import { usePiSocket } from "@/hooks/usePiSocket";

export type PiSocketCtxValue = {
  piRate?: number | null;
  basePI?: number | null;
  totalPI?: number | null;
  quotedUSD?: number | null;
  feePercent?: number | null;
  requestPriceUpdate?: (usd: number, offerId: string) => void;
};

const PiSocketContext = createContext<PiSocketCtxValue | null>(null);

export function PiSocketProvider({ children }: { children: React.ReactNode }) {
  const value = usePiSocket(); // must return matching shape
  return (
    <PiSocketContext.Provider value={value}>
      {children}
    </PiSocketContext.Provider>
  );
}

export function usePiSocketCtx(): PiSocketCtxValue {
  const ctx = useContext(PiSocketContext);
  if (!ctx) throw new Error("usePiSocketCtx must be used within PiSocketProvider");
  return ctx;
}

/** Like usePiSocketCtx but returns null outside the provider (no throw). */
export function useOptionalPiSocketCtx(): PiSocketCtxValue | null {
  return useContext(PiSocketContext);
}
